import { render, staticRenderFns } from "./BranchSales.vue?vue&type=template&id=4f45e614"
import script from "./BranchSales.vue?vue&type=script&lang=js"
export * from "./BranchSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports